import { createPortal } from 'react-dom'
import { useLocation, Outlet } from 'react-router-dom'
import { useTelegramWebApp } from '../../hooks/useTelegramWebApp'
import { ROUTES } from '@shared/config/routes'
import Header from './Header'
import BottomMenu from '../BottomMenu/BottomMenu'
import './Layout.css'

const Layout = () => {
  const location = useLocation()
  const { webApp } = useTelegramWebApp()

  // На главной шапка (логотип, счётчик, аватар) отрисована внутри баннера,
  // поэтому отдельный Header там не нужен. На калькуляторе себестоимости она
  // тоже лишняя: это рабочий экран со своим заголовком, а логотип со счётчиком
  // отъедают верх и в Telegram упираются в системную шапку.
  const showHeader =
    location.pathname !== '/profile' &&
    location.pathname !== '/' &&
    location.pathname !== ROUTES.COST_CALCULATOR

  // На калькуляторе нижнее меню перекрывает поля и итог — это рабочий экран
  // с формой, из него возвращаются кнопкой «назад».
  const showBottomMenu = location.pathname !== ROUTES.COST_CALCULATOR

  return (
    <div className="layout">
      {showHeader && <Header />}
      <main className="main-content">
        <Outlet />
      </main>
      {/* Меню выносим порталом из потока страницы: при свайпе назад контент
          едет за пальцем через transform, а transform на предке переопределяет
          систему координат для position: fixed — меню уехало бы вниз документа. */}
      {showBottomMenu && createPortal(<BottomMenu />, document.body)}
    </div>
  )
}

export default Layout
